import React from 'react';

import Lozenge from '@atlaskit/lozenge';
import { Flex } from '@atlaskit/primitives';

import { PRIORITIES } from '../common/ui/constants';
import { type PriorityBadgeProps } from '../common/ui/types';

export default function PriorityBadge({ priority }: PriorityBadgeProps) {
	const { label, ...lozengeProps } = PRIORITIES[priority];
	return (
		<Flex>
			<Lozenge {...lozengeProps}>{priority}</Lozenge>
		</Flex>
	);
}
